// Tells the part-mapping owners that a BOM was created short a part.
//
// Kevin, 2026-08-21: "if a part is missing ... also send an email to cody@, kmagallon@,
// jared@ and rob@". The endpoint sends it once per configuration; this is only the call.
//
// FIRE AND FORGET, like recordError. It runs AFTER the item, BOM and routing already exist,
// so nothing about it can undo a successful submit -- and a mail failure must not turn a save
// that worked into an error the user sees. Everything is swallowed.

export type MissingPartNotice = {
  /** The configuration's fingerprint. The endpoint de-duplicates on it. */
  fingerprint: string;
  /** Component families with no item mapped, e.g. ["core plug"]. */
  missing: string[];
  itemid?: string;
  /** The BOM name as created -- which carries the leading "!" when a part is missing. */
  bomName?: string;
  product?: string;
  submittedBy?: string;
  /** Anything worth reading in the email: the answers that led here, in prose. */
  detail?: string;
};

export function reportMissingParts(notice: MissingPartNotice): void {
  if (!notice.missing?.length || !notice.fingerprint) return;
  try {
    void fetch("/api/missing-part-notice", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(notice),
    }).catch(() => {
      // The endpoint already answers 200 for its own failures; this catches the network
      // being gone entirely, which is not worth telling the user about here.
    });
  } catch {
    // Never let reporting a gap become a second problem.
  }
}
